import React, { useContext, useEffect, useState } from "react";
import "./login-signup.css";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import { Context } from "../../../utils/Context";
import { useForm } from "react-hook-form";
import { CookiesName, ValidationErrorsSet } from "../../../utils/common";
import classNames from "classnames";
import { ChangePassword } from "../../../utils/apis/admin";

const ChangePassword_modal = (props) => {
  //   const [resistermodal, setRegistermodal] = useState(false);
  //
  const { GETUser } = useContext(Context);
  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
    setError,
    clearErrors,
    getValues,
    reset,
  } = useForm({
    defaultValues: {
      old_password: "",
      new_password: "",
      confirm_new_password: "",
    },
  });

  const onSubmit = async (data) => {
    try {
      const res = await ChangePassword(data);

      if (res?.success) {
        GETUser();
        reset();
        props.onHide();
      } else {
        ValidationErrorsSet(setError, res.errors);
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  useEffect(() => {
    if (!props?.show) {
      reset();
    }
  }, [props?.show]);

  return (
    <>
      <Modal
        {...props}
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="login_signup_sec"
        backdrop="static"
      >
        <Modal.Header closeButton></Modal.Header>

        <Modal.Body>
          <div className="form-sec">
            <h6 className="contacttitle">Change Password</h6>
            <Form onSubmit={handleSubmit(onSubmit)}>
              <div className="form-group">
                <Form.Label>Old Password</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter your Old Password"
                  {...register("old_password", {
                    required: "Old Password is required",
                  })}
                  className={classNames("", {
                    "is-invalid": errors?.old_password,
                  })}
                />
                {errors.old_password && (
                  <Form.Text className="invalid-feedback">
                    {errors.old_password.message}
                  </Form.Text>
                )}
              </div>

              <div className="form-group">
                <Form.Label>New Password</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter your New Password"
                  {...register("new_password", {
                    required: "New Password is required",
                  })}
                  className={classNames("", {
                    "is-invalid": errors?.new_password,
                  })}
                />
                {errors.new_password && (
                  <Form.Text className="invalid-feedback">
                    {errors.new_password.message}
                  </Form.Text>
                )}
              </div>

              <div className="form-group">
                <Form.Label>Confirm New Password</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter your Confirm New Password"
                  {...register("confirm_new_password", {
                    required: "Confirm New Password is required",
                  })}
                  className={classNames("", {
                    "is-invalid": errors?.confirm_new_password,
                  })}
                />
                {errors.confirm_new_password && (
                  <Form.Text className="invalid-feedback">
                    {errors.confirm_new_password.message}
                  </Form.Text>
                )}
              </div>

              <div className="form-group">
                <button type="submit" className="submitbtn">
                  Change Password
                </button>
              </div>
            </Form>
            <div className="lefttop"></div>
            <div className="righttop"></div>
            <div className="leftbot"></div>
            <div className="rightbot"></div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default ChangePassword_modal;
